import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaqItem } from '../content/faq';
import { ICON_PATHS } from './icons';

/// Yerel <details>/<summary>: klavye (Tab + Enter/Boşluk) ve ekran okuyucu
/// desteği tarayıcıdan gelir; JS gerektirmez.
@Component({
    selector: 'site-faq-accordion',
    imports: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="divide-y divide-solid divide-surface-line rounded-2xl border-[1px] border-solid border-surface-line bg-white">
      @for (item of items(); track item.id) {
        <details class="group" [attr.id]="'soru-' + item.id">
          <summary
            class="flex min-h-tap cursor-pointer list-none items-center justify-between gap-[1rem] px-[1.25rem] py-[1rem] text-base font-semibold text-ink [&::-webkit-details-marker]:hidden"
          >
            <span>{{ item.question }}</span>
            <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="h-5 w-5 shrink-0 text-brand-700 transition-transform group-open:rotate-45">
              <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="icons.plus" />
            </svg>
          </summary>
          <div class="px-[1.25rem] pb-[1.25rem] text-ink-muted">
            <p>{{ item.answer }}</p>
            @if (item.link) {
              <p class="mt-2"><a [routerLink]="item.link.path" class="font-semibold">{{ item.link.label }}</a></p>
            }
          </div>
        </details>
      }
    </div>
  `
})
export class FaqAccordionComponent {
  readonly items = input.required<readonly FaqItem[]>();
  readonly icons = ICON_PATHS;
}
